/**
 * 媒体地址归一化。
 *
 * **为什么需要：**
 * 早期后端上传接口回的是绝对地址 `http://127.0.0.1:8000/static/uploads/...`，
 * 那批地址已经写进了后端库和浏览器 localStorage 镜像里。写侧后来修好了
 * （`storage.save_bytes` 回 `relUrl`），但**读侧不归一，老数据就永远是坏的**。
 *
 * 绝对地址的三种死法：
 *   1. 换端口 / 换机器 → 指向别人的 8000
 *   2. 内嵌 webview / 预览器里加载不出来（本项目踩过，表现为"功能都对、图全碎"）
 *   3. 跨设备打开必挂
 *
 * 规则：只认自家的静态资源。地址里出现 `/static/uploads/` 就从那里截断，
 * 前面不管是 127.0.0.1、localhost 还是别的什么主机名，一律丢掉。
 * 外部地址（图床、CDN）原样返回。
 */
const STATIC_MARKER = '/static/uploads/'

export function toRelUrl(url: string): string {
  if (!url) return url
  if (!/^https?:\/\//i.test(url)) return url // 已经是相对地址

  const idx = url.indexOf(STATIC_MARKER)
  if (idx <= 0) return url

  const host = url.slice(0, idx)
  // 只处理「像本机/同源」的绝对地址，避免误伤真的挂在域名下的静态资源
  if (!/^https?:\/\/(127\.0\.0\.1|localhost|\[::1\])(:\d+)?$/i.test(host)) return url

  return url.slice(idx)
}

/**
 * 图床主机名 → 给用户看的**短标签**。
 *
 * 后端 `UploadResult.host` 回的是**真实主机名**（`i.ibb.co`、
 * `hermes-songshu-1254106699.cos.ap-guangzhou.myqcloud.com`）—— 排查时看的正是它，
 * 所以不能为了让标签好看就让后端改小名。折成短标签这件事只发生在**显示层**。
 *
 * ⚠️ 认不出的主机**原样显示**，不要统称成「图床」：那张图确实是挂在别处的，
 * 抹掉来源等于下次排查时少一条线索。
 * ⚠️ 2026-10-01 起图床是两级链（ImgBB → 腾讯云 COS 兜底），所以映射有两家。
 */
const HOST_LABELS: [RegExp, string][] = [
  [/^i\.ibb\.co$/i, 'ImgBB'],
  [/\.cos\.[a-z0-9-]+\.myqcloud\.com$/i, '腾讯云 COS'],
]

export function imgHostLabel(host: string): string {
  if (!host) return ''
  for (const [re, label] of HOST_LABELS) if (re.test(host)) return label
  return host
}
